import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IApplication, IJobOffer } from '../../../../../assets/types/dtoTypes';

@Injectable( {
  providedIn: 'root',
} )
export class JobsDetailsService {
  private http = inject(HttpClient);


  private jobsUrl = `${environment.apiUrl}/job-offers`;

  private applicationsUrl = `${environment.apiUrl}/job-applications`;

  private interviewsUrl = `${environment.apiUrl}/interviews/job-application`;



  constructor() {}

  public getJobOffer( id: string ): Observable<IJobOffer> {
    const url = `${this.jobsUrl}/${id}`;
    return this.http.get<IJobOffer>( url );
  }

  getAllApplications( jobId: string ): Observable<IApplication[]> {
    const url = `${this.applicationsUrl}/job/${jobId}`;
    return this.http.get<IApplication[]>( url );
  }

  shortlist( id: string ): Observable<string> {
    const url = `${this.applicationsUrl}/${id}/status`;
    return this.http.put<string>( url, { status: 'SHORTLISTED' } );
  }

  inviteToInterview(
    applicationId: string,
    date: string,
    startTime: string,
    endTime: string,
    guests: { guestEmail: string; guestName: string; guestId: string }[],
    title = 'Interview'
  ): Observable<IApplication> {
    const url = `${this.interviewsUrl}/${applicationId}`;
    return this.http.post<IApplication>(url, {
      title,
      date,
      startTime,
      endTime,
      guests,
    });
  }

  accept( id: string ): Observable<IApplication> {
    const url = `${this.applicationsUrl}/${id}/status`;
    return this.http.put<IApplication>( url, { status: 'ACCEPTED' } );
  }

  offer( id: string ): Observable<IApplication> {
    const url = `${this.applicationsUrl}/${id}/status`;
    return this.http.put<IApplication>( url, { status: 'OFFERED' } );
  }

  reject( id: string ): Observable<IApplication> {
    const url = `${this.applicationsUrl}/${id}/status`;
    return this.http.put<IApplication>( url, { status: 'REJECTED' } );
  }

  revertStatus( id: string, previousStatus: string ): Observable<IApplication> {
    const url = `${this.applicationsUrl}/${id}/status`;
    return this.http.put<IApplication>( url, { status: previousStatus } );
  }

  candidateAccept( id: string ): Observable<IApplication> {
    return this.http.post<IApplication>( `${this.applicationsUrl}/${id}/accept`, {} );
  }

  candidateRefuse( id: string, reason = '' ): Observable<IApplication> {
    return this.http.post<IApplication>( `${this.applicationsUrl}/${id}/refuse`, { reason } );
  }
}
